<template>
    <div>
        <h1 class="text-h5 my-5">
            Billing
            <v-progress-circular v-if="loading" indeterminate color="green" class="ml-2"/>
        </h1>
        <v-alert v-if="alert.msg" :color="alert.color" icon="mdi-alert-octagon-outline" outlined text dismissible>
            {{alert.msg}}
        </v-alert>

        <v-simple-table dense class="table">
            <tbody>
            <tr v-for="f in fields">
                <td>{{f.name}}</td>
                <td>
                    <v-chip v-if="f.status" :color="f.status" label class="chip">{{f.value}}</v-chip>
                    <span v-else>{{f.value}}</span>
                </td>
            </tr>
            </tbody>
        </v-simple-table>

        <div v-if="action === 'activate'">
            <div>Choose a plan (<a href="/pricing" target="_blank">compare plans</a>):</div>
            <v-radio-group v-model="plan" class="mt-0" mandatory>
                <div v-for="p in plans" class="my-2">
                    <v-radio :value="p.name" :disabled="!!p.disabled" class="mb-0">
                        <template #label>
                            <div class="mt-0">
                                <span class="font-weight-medium">{{p.name}}:</span>
                                <span class="ml-2">{{p.price}}</span>
                            </div>
                        </template>
                    </v-radio>
                    <div class="ml-8">
                        <div v-if="p.description" class="caption">
                            All features from the Pro plan + Single Sign-On (SSO) + Priority Support.
                        </div>
                        <div v-if="p.disabled === 'sso'" class="caption" style="color: rgba(0,0,0,0.87)">
                            This plan does not support Single Sign-On (SSO).
                            To select this plan, please disable the <router-link :to="{params: {tab: 'team'}}">SSO integration</router-link>.
                        </div>
                    </div>
                </div>
            </v-radio-group>
            <v-btn @click="post(action)" :disabled="!canEdit || !plan" color="primary">
                Activate subscription
            </v-btn>
        </div>
        <div v-else>
            <v-btn @click="post(action)" :disabled="!canEdit" color="primary">
                Manage subscription
            </v-btn>
            <Chart v-if="chart" :chart="chart" class="my-3" />
        </div>
    </div>
</template>

<script>
import Chart from "@coroot/coroot/src/components/Chart.vue";

export default {
    props: {
        workspaceId: String,
    },

    components: {Chart},

    data() {
        return {
            access: '',
            alert: {msg: '', color: ''},
            loading: false,
            fields: [],
            action: '',
            chart: null,
            plans: [],
            plan: '',
        };
    },

    computed: {
        canEdit() {
            return this.access === 'edit';
        },
    },

    mounted() {
        this.get();
    },

    methods: {
        get() {
            this.loading = true;
            this.$api.billing(this.workspaceId, null,(data, meta) => {
                this.loading = false;
                if (meta.error) {
                    this.alert.msg = 'Failed to get billing details. Please try again later.'
                    this.alert.color = 'red';
                    return;
                }
                this.access = data.access;
                this.fields = data.fields || [];
                this.plans = data.plans || [];
                this.action = data.action;
                this.chart = data.chart;
                if (!this.canEdit) {
                    this.alert.msg = 'You are not allowed to configure billing details.'
                    this.alert.color = 'primary';
                }
            });
        },
        post(action) {
            this.loading = true;
            const form = {action, return_path: this.$route.fullPath, plan: this.plan};
            this.$api.billing(this.workspaceId, form, (data, meta) => {
                this.loading = false;
                if (meta.error) {
                    this.alert.msg = 'Failed to get subscription details. Please try again later.'
                    this.alert.color = 'red';
                    return;
                }
                window.location.href = data.url;
            });
        },
    },
}
</script>

<style scoped>
.table {
    margin-bottom: 20px;
}
.table tr:hover {
    background-color: unset !important;
}
.table td {
    border-bottom: unset !important;
}
.table tr td:first-child {
    max-width: 30ch;
    padding-left: 0;
}
.table .chip {
    height: 20px;
    padding: 0 8px;
}
</style>